import React, { useContext } from 'react'
import Modal from '../../../../../components/Modal/Modal'
import { useNavigate, useParams } from 'react-router-dom'
import { CampaignContext } from '../../../../../contexts/CampaignContext'

export default function MustSelectScenarioModal() {
  const navigate = useNavigate()
  const { id } = useParams()
  const { campaignScenarios } = useContext(CampaignContext)

  return (
    <Modal isOpen={true} onClose={() => { }} hasSideBar>
      <Modal.Body>
        <div className="flex flex-col gap-4">
          <h4 className='text-2xl font-bold text-rb-green text-center'>Campaign data loading</h4>
          <div className='max-w-[500px] flex flex-col gap-2'>
            <p>We couldn’t load scenario data needed for drafts yet{campaignScenarios?.length === 0 ? '.' : '; try refreshing the page.'}</p>
            {!campaignScenarios?.length && (
              <p>Open the budget table or project timeline once the campaign has finished loading.</p>
            )}
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-full flex justify-between items-center">
          <button
            type="button"
            className="bg-rb-green text-white font-bold rounded-lg p-2 px-4"
            onClick={() => navigate(`/project_manager/campaigns/${id}/budget_table`)}
          >
            Go to Budget
          </button>
          <button
            type="button"
            className="bg-rb-green text-white font-bold rounded-lg p-2 px-4"
            onClick={() => navigate(`/project_manager/campaigns/${id}/project_timeline`)}
          >
            Go to Timeline
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  )
}
